export const courses = [
  {
    id: 1,
    name: '수능 국어 완성반',
    level: '고3',
    description: '수능 국어 1등급을 위한 체계적인 커리큘럼',
    schedule: '매주 수요일 6~10시',
    capacity: '20명',
    price: '월 480,000원',
    features: ['기출 문제 완벽 분석', '실전 모의고사', '1:1 첨삭 지도'],
    isPopular: true
  },
  {
    id: 2,
    name: '학교별 내신반 편성',
    level: '고1-고2',
    description: '내신 1등급을 위한 심화 학습',
    schedule: '학교별 요일 시간 학원 문의',
    capacity: '20명',
    price: '월 420,000원',
    features: ['교과서 완벽 분석', '학교별 맞춤 지도', '서술형 집중 훈련']
  },
  {
    id: 5,
    name: '약술형 소논술반',
    level: '고3',
    description: '약술형·소논술 서술 능력 완성',
    schedule: '학원 문의',
    capacity: '15명',
    price: '월 350,000원',
    features: ['약술형 답안 작성법', '소논술 첨삭 지도', '학교별 기출 분석']
  }
];

export const schedulesByLocation = [
  {
    id: 1,
    name: '운정점',
    schedules: [
      { school: '지산고1', time: '월 또는 화 오후 06~10시' },
      { school: '동패고1', time: '월 또는 화 오후 06~10시' },
      { school: '운정고1', time: '금요일 오후 06~10시' },
      { school: '다율고1', time: '토요일 오전 10~02시' },
      { school: '지산고2', time: '일요일 오후 03~07시' },
      { school: '동패고2', time: '일요일 오후 06~10시' },
      { school: '수능정시반', time: '수요일 오후 06~10시' }
    ]
  },
  {
    id: 2,
    name: '금촌점',
    schedules: [
      { school: '금촌고1', time: '토요일 오후 04시~07시' },
      { school: '금촌고2', time: '토요일 오후 01시~04시' },
      { school: '금촌고3', time: '토요일 오후 07시~10시' }
    ]
  }
];

export const scheduleTypes = [
  {
    id: 1,
    type: '오전반',
    time: '09:00 - 12:00',
    description: '집중력이 높은 오전 시간대',
    color: 'mint'
  },
  {
    id: 2,
    type: '오후반',
    time: '14:00 - 17:00',
    description: '여유로운 오후 학습',
    color: 'coral'
  },
  {
    id: 3,
    type: '저녁반',
    time: '19:00 - 22:00',
    description: '학교 수업 후 심화 학습',
    color: 'navy'
  }
];

export const weekdaySchedules = [
  {
    id: 1,
    name: '월/수/금 집중반',
    description: '주 3회 집중 학습으로 효율적인 실력 향상',
    icon: 'clock'
  },
  {
    id: 2,
    name: '화/목 심화반',
    description: '주 2회 심화 과정으로 깊이 있는 학습',
    icon: 'calendar'
  }
];
